module.exports = __webpack_public_path__ + "img/手机顶部.43147b71.png";